import { defineMessages } from 'react-intl';

export const MAX_UNCOLLAPSED_REPIES = 5;
export const STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD = 125;
export const STICKY_COMMENT_VERTICAL_OFFSET_VIEW = 122;

export const i18n: {
	closeCommentBox: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeInlineCommentThread: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeSidebarTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closeReactionTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reactionSidebarLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllCommentsButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentSidebarLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentSidebarAnnouncement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closeCommentBox: {
		id: 'annotation-provider-inline-comments.closeCommentBox',
		defaultMessage: 'Close inline comments',
		description:
			'The text is shown on a button that closes the inline comments panel when clicked.',
	},
	closeInlineCommentThread: {
		id: 'annotation-provider-inline-comments.close.InlineCommentThread',
		defaultMessage: 'Close inline comment thread',
		description: 'Button to close this inline comments thread (comment and replies)',
	},
	closeSidebarTooltip: {
		id: 'annotation-provider-inline-comments.close.icon.tooltip',
		defaultMessage: 'Close comment',
		description: 'A tooltip message informing the user what the icon does on hover and its hotkey',
	},
	closeReactionTooltip: {
		id: 'annotation-provider-inline-comments.close.reaction.tooltip',
		defaultMessage: 'Close reaction',
		description: 'A tooltip message for the close button when displaying an inline reaction',
	},
	reactionSidebarLabel: {
		id: 'annotation-provider-inline-comments.reaction.sidebar.label',
		defaultMessage: 'Inline reaction',
		description: 'ARIA label for the inline reaction sidebar for screen readers',
	},
	viewAllCommentsButtonText: {
		id: 'annotation-provider-inline-comments.view-all.button.text',
		defaultMessage: 'View all',
		description:
			'Button text for inline comments header that opens the comments panel in right rail',
	},
	commentSidebarLabel: {
		id: 'annotation-provider-inline-comments.comment.sidebar.label',
		defaultMessage: 'Inline comment by {name}',
		description:
			'ARIA label for the inline comment sidebar for screen readers, with the comment author name',
	},
	commentSidebarAnnouncement: {
		id: 'annotation-provider-inline-comments.comment.sidebar.announcement',
		defaultMessage: 'Comment sidebar shown, use Shift + Tab to reach the comment sidebar',
		description:
			'An annoucement that the comment sidebar was shown and telling the user how to access it with the keyboard',
	},
});
